import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './contexts/AppProvider';
import { Toaster } from 'sonner';
import EvaaSurveyPreviewPage from './components/pages/PreviewSurveyPage';

import MainLayout from './layouts/MainLayout';
import Tabs from './components/Tabs';
// App content - This is what goes inside the layout
function AppContent() {
	return (
		<Routes>
			<Route path="/" element={
				<MainLayout>
				</MainLayout>}
			/>
			<Route path="/:tenant_id/:access_token/" element={
				<MainLayout>
					<Toaster richColors position="top-right" />
					<Tabs /> 
				</MainLayout>}
			/>
			<Route path="/:tenant_id/:access_token/survey-preview" element={<EvaaSurveyPreviewPage />} />
		</Routes>
	);
}

function App() {
	return (
		<BrowserRouter>
			<AppProvider>
					<AppContent />
			</AppProvider>
		</BrowserRouter>
	);
}

export default App;